export function OptionMenuItem({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex gap-x-1 items-center hover:bg-gray-200 rounded-[4px] py-[6px] cursor-pointer px-[6px]">
            {children}
        </div>
    );
}